import { Move, MoveUuid, ProductTraceabilityGroupUuid } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface CreateMoveRequest {
    itemId: number | null
    quantity: number | null
    sourceLocationUuid: string | null
    destinationLocationUuid: string | null
    productTraceabilityGroupUuid?: ProductTraceabilityGroupUuid | null
}

export default (axios: AxiosInstance = baseAxios): { createMove: (request: CreateMoveRequest) => Promise<Move>; deleteMove: (uuid: MoveUuid) => Promise<boolean>; } => ({
    createMove: async (request: CreateMoveRequest): Promise<Move> => {
        const response = await axios.post<{ data: Move }>('/api/moves', request);
        return response.data.data;
    },

    deleteMove: (uuid: MoveUuid): Promise<boolean> => {
        return axios
            .delete(`/api/moves/${uuid}`)
            .then(() => true);
    },
});
